import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b7a9232"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "readonly" }, "BenefitMe", -1))
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "nav-wrapper" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_8 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { href: "https://client.benefitme.ch" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Text = _resolveComponent("Text")!
  const _component_LocalSelector = _resolveComponent("LocalSelector")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Flex = _resolveComponent("Flex")!
  const _component_Container = _resolveComponent("Container")!

  return (_ctx.data)
    ? (_openBlock(), _createElementBlock("header", _hoisted_1, [
        _createVNode(_component_Container, { size: "large" }, {
          default: _withCtx(() => [
            _createVNode(_component_Flex, {
              class: "header-content",
              justifyContent: "space-between"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, {
                  to: _ctx.data.Navigation.Logo.Href
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Title, {
                      tag: "h1",
                      size: "small",
                      color: "dark"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2,
                        _createElementVNode("img", {
                          src: _ctx.backendUrl + _ctx.data.Navigation.Logo.Image.data.attributes.url,
                          alt: ""
                        }, null, 8, _hoisted_3)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["to"]),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("button", {
                    class: _normalizeClass(`cross ${_ctx.isExpanded && ' expanded'}`),
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isExpanded = !_ctx.isExpanded))
                  }, _hoisted_8, 2),
                  _createVNode(_component_Flex, {
                    id: "nav",
                    alignItems: "center",
                    class: _normalizeClass(_ctx.isExpanded && 'expanded')
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.Navigation.Link, (link, index) => {
                        return (_openBlock(), _createBlock(_component_router_link, {
                          key: index,
                          to: link.Href,
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isExpanded = false))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Text, {
                              value: link.Label,
                              size: "header-link"
                            }, null, 8, ["value"])
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      }), 128)),
                      _createVNode(_component_LocalSelector),
                      _createElementVNode("a", _hoisted_9, [
                        _createVNode(_component_Button, {
                          value: "Login",
                          color: "dark",
                          small: true
                        })
                      ])
                    ]),
                    _: 1
                  }, 8, ["class"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}